import VS from 'constants/ValidationShema';
import Tr from "translations/Translations";
import {VALUES} from "./AuditTaskStatus";

export default (auditTaskStatus) => {

    return VS.object({
        name: VS.stringMax(400),
        startDate: VALUES.PREPARING === auditTaskStatus ? VS.dateTimeMin(new Date(), Tr('audit_task_date_start_invalid')) : VS.dateTimeValid(),
        endDate: VS.dateTimeValid().when('startDate', (startDate, schema) => {
            return schema.test('afterStartDate', Tr("audit_task_date_end_after_start"), (endDate) => {
                if (endDate && startDate) {
                    return startDate.isBefore(endDate);
                }
                return true;
            });
        }),
        type: VS.string(),
        allowedObjects: VS.lazy(() => {
            return VS.arrayOfShape({
                objectIdentity: VS.integerMin(1),
                objectType: VS.string()
            })
        }),
        allowedObjectsCount: VS.any().test(
            'auditUsersCount',
            Tr('audit_task_allowed_object_empty'),
            (formValue) => {
                return formValue.count > 0;
            }
        ),
        auditUsers: VS.lazy(() => {
            return VS.arrayOfShape({
                firstName: VS.string(),
                lastName: VS.string(),
                email: VS.emailMax(250)
            })
        }),
        auditUsersCount: VS.any().test(
            'auditUsersCount',
            Tr('audit_task_users_empty'),
            (formValue) => {
                return formValue.count > 0;
            }
        )
    })
}